import { render, staticRenderFns } from "./TabCob.vue?vue&type=template&id=d5eb4ad2&"
import script from "./TabCob.vue?vue&type=script&lang=js&"
export * from "./TabCob.vue?vue&type=script&lang=js&"
import style0 from "./TabCob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports